<template>
 <div>    
    <div class="container">
      <div class="row">
        <div class="col-12"></div>
        <h3>{{ getTranslations("tags_available") }}</h3>
        </div>          
    </div>
    <div class="row">
      <div class="col-4">
        <b>{{ getTranslations("tag") }}</b>
      </div>
      <div class="col-4">
        <b>Slug</b>
      </div>        
    </div>    
    <div class="row" v-for="item in this.input_tags" :key="item.id">
      <div class="col-4">
        {{ getTranslate(item.name) }}
      </div>
      <div class="col-4">
        {{ item.slug }} 
      </div>
    </div>      
    <div class="form-group" v-for="lang in langs">
      <label>{{ getTranslations("message") }} ({{ getTranslations("language") }} {{ lang }})</label>          
      <textarea v-bind:name="getInputNameTranslate(name, lang)" v-model="values[lang]" class="form-control" rows="1"></textarea>    
    </div>

 </div>
</template>

<script>
export default {
  mounted() {
      
  },
  data()  {
      return {
          name: this.input_name,
          tags: this.input_tags,          
          values: this.input_values,
          langs: this.input_langs,
          user_lang: this.input_user_lang,
          translations: this.input_translations
      }
  },
  methods:{
    getTranslate(value){       
      if (typeof value[this.user_lang] === 'undefined'){
        return value["en"];
      } else {
        return value[this.user_lang];
      }      
    },
    getTranslations(index){            
      return this.translations[index];
    },
    getInputNameTranslate(inputName, lang){
      return inputName + "[" + lang + "]";
    }    
  },
  props: {
    input_name: {
      type: String,
      required: true
    },
    input_tags: {
      type: Array            
    },
    input_values: {
      type: Object      
    },
    input_langs:{
      type: Array      
    },
    input_user_lang: {
      type: String     
    },
    input_translations: {
      type: Object
    }
  }
}
</script>

<style scoped>
textarea{
  height: 8rem !important;
}
</style>